import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Img from '../../../../components/Img';
import { trackEvent } from '../../../../components/Analytics/TrackedClick';
import { getClickAttrs } from '../../../../components/Analytics/gtag';
import { TrackingData } from '../constants';

import style from './cardGrid.scss';

const { TITLE, ACTION, PAGE, SUBSCRIBER_TYPE_POWER, BUTTON_SHOP_AT, BUTTON_COPY } = TrackingData;

const Redeem = ({ title, isPowered, hasPastDueSubscription, method, code, handleLinkClick, handlePowerClick, handleCloseClick, ctaVerb, 'data-testid': dataTestId }) => {
    const history = useHistory();
    const [copied, setCopied] = useState();

    const handleCopyClick = () => {
        // segment call - mapped to GA4
        trackEvent(TITLE, {
            page: PAGE,
            partner: title,
            button: BUTTON_COPY,
            action: ACTION,
            subscriberType: SUBSCRIBER_TYPE_POWER,
        });
        navigator.clipboard.writeText(code);
        setCopied(true);
    };

    const onPowerClick = () => {
        handlePowerClick();
        handleCloseClick();
    };

    const onResumePowerClick = () => {
        trackEvent(TITLE, {
            page: PAGE,
            partner: title,
            button: `Resume Power to ${ctaVerb}`,
            action: ACTION,
            subscriberType: SUBSCRIBER_TYPE_POWER,
        });
        history.push('/subscriptions');
        handleCloseClick();
    };

    if (hasPastDueSubscription) {
        return (
            <div
                className={`${style.redeem} clickable`}
                onClick={onResumePowerClick}
                {...getClickAttrs({
                    category: 'Resume Power',
                    context: `Power Perks Perk Detail Resume Power Button ${title} Click`,
                    location: 'Power Perks Page - Perk Card Details Modal',
                })}
                data-testid={dataTestId}
            >
                <Img src="/img/v3/icons/perks/lock 18 black.svg" /> Resume Power to {ctaVerb}
            </div>
        );
    }

    if (!isPowered) {
        return (
            <div
                className={`${style.redeem} clickable`}
                onClick={onPowerClick}
                {...getClickAttrs({
                    category: `Power Perks`,
                    context: `Power Perks Perk Detail Upgrade Start Power Button ${title} Click`,
                    location: 'Power Perks Page - Perk Card Details Modal',
                })}
                data-testid={dataTestId}
            >
                <Img src="/img/v3/icons/perks/lock 18 black.svg" /> Start Power to {ctaVerb}
            </div>
        );
    }

    if (method === 'link') {
        return (
            <div className={`${style.redeem} ${style.button} clickable`} onClick={handleLinkClick} data-testid={dataTestId}>
                Redeem Perk
            </div>
        );
    }

    if (method === 'code') {
    return (
        <div className={style.redeem} data-testid={dataTestId}>
            {code}
            <div
                className={style.copy}
                onClick={handleCopyClick}
                {...getClickAttrs({
                    category: `Power Perks`,
                    context: `Power Perks Perk Detail Active Redeem Copy ${title} Click`,
                    location: 'Power Perks Page - Perk Detail Card',
                })}
                data-testid={dataTestId && `${dataTestId}.copy-btn`}
            >
                {copied ? <><Img src="/img/v3/icons/icon-20px-check-blue.svg" /> Copied</> : 'Copy'}
            </div>
        </div>
    );
    }
    return null;
};

const PerkModalContent = (props) => {
    const { title, description, region, content, terms, code, link, method, isPowered, hasPastDueSubscription, handlePowerClick, handleCloseClick, ctaVerb, 'data-testid': dataTestId } = props;

    const handleLinkClick = () => {
        trackEvent(TITLE, {
            page: PAGE,
            partner: title,
            button: `${BUTTON_SHOP_AT} ${title}`,
            action: ACTION,
            subscriberType: SUBSCRIBER_TYPE_POWER,
        });
        window.open(link, '_blank').focus();
    };

    return (
        <div className={style.perkModalContent} data-testid={dataTestId}>
            <div className={style.title} data-testid={dataTestId && `${dataTestId}.title`}>
                {title}
            </div>
            <div className={style.description} data-testid={dataTestId && `${dataTestId}.description`}>
                {description}
            </div>
            {region && (
            <div className={style.region} data-testid={dataTestId && `${dataTestId}.region`}>
                <Img src="/img/v3/icons/icon-16x-globe.svg" /> {region}
            </div>
            )}
            <div className={style.content} data-testid={dataTestId && `${dataTestId}.content`}>
                {content}
            </div>
            {!!terms && (
                <div className={style.terms} data-testid={dataTestId && `${dataTestId}.terms`}>
                    <b>Terms and conditions</b><br />
                    {terms}
                </div>
            )}
            <Redeem
                title={title}
                code={code}
                isPowered={isPowered}
                hasPastDueSubscription={hasPastDueSubscription}
                method={method}
                link={link}
                handlePowerClick={handlePowerClick}
                handleCloseClick={handleCloseClick}
                handleLinkClick={handleLinkClick}
                ctaVerb={ctaVerb}
                data-testid={dataTestId && `${dataTestId}.redeem`}
            />
            {method === 'code' && isPowered && (
                <div
                    className={`${style.redeem} ${style.button} clickable mt8`}
                    onClick={handleLinkClick}
                    {...getClickAttrs({
                        category: `Power Perks`,
                        context: `Power Perks Perk Detail ${method === 'link' ? 'Active Redeem' : 'Partner Link'} ${title} Click`,
                        location: 'Power Perks Page - Perk Detail Card',
                    })}
                    data-testid={dataTestId && `${dataTestId}.shop-link`}
                >
                    Shop at {title}
                </div>
            )}
        </div>
    );
};

export default PerkModalContent;
